import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const mockContractors = [{
  id: 1,
  name: 'Juan Pérez',
  identification: '12345678',
  email: 'juan@ejemplo.com',
  phone: '987654321',
  zone: 'Zona Norte',
  locality: 'Lima Norte',
  territory: 'Territorio A',
  active: true
}, {
  id: 2,
  name: 'María García',
  identification: '87654321',
  email: 'maria@ejemplo.com',
  phone: '123456789',
  zone: 'Zona Sur',
  locality: 'Lima Sur',
  territory: 'Territorio B',
  active: false
}];
export const ContractorsTable = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(mockContractors.length / itemsPerPage);
  return <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-250">
      <div className="overflow-x-auto" data-id="element-251">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-252">
          <thead className="bg-gray-50" data-id="element-253">
            <tr data-id="element-254">
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-255">
                Nombre
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-256">
                Identificación
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-257">
                Contacto
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-258">
                Ubicación
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-259">
                Estado
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-260">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-261">
            {mockContractors.map((contractor, index) => <tr key={contractor.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-262">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-263">
                  <div className="text-sm font-medium text-gray-900" data-id="element-264">
                    {contractor.name}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-265">
                  <div className="text-sm text-gray-900" data-id="element-266">
                    {contractor.identification}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-267">
                  <div className="text-sm text-gray-500" data-id="element-268">
                    {contractor.email}
                    <br data-id="element-269" />
                    {contractor.phone}
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-270">
                  <div className="text-sm text-gray-500" data-id="element-271">
                    {contractor.zone}
                    <br data-id="element-272" />
                    {contractor.locality}
                    <br data-id="element-273" />
                    {contractor.territory}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-274">
                  <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${contractor.active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-275">
                    {contractor.active ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-276">
                  <button className={`px-4 py-2 text-sm font-medium text-white rounded-lg ${contractor.active ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'}`} data-id="element-277">
                    {contractor.active ? 'Desactivar' : 'Activar'}
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" data-id="element-278">
        <div className="flex-1 flex justify-between sm:hidden" data-id="element-279">
          <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-280">
            Anterior
          </button>
          <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-281">
            Siguiente
          </button>
        </div>
        <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-282">
          <div data-id="element-283">
            <p className="text-sm text-gray-700" data-id="element-284">
              Mostrando <span className="font-medium" data-id="element-285">1</span> a{' '}
              <span className="font-medium" data-id="element-286">{mockContractors.length}</span> de{' '}
              <span className="font-medium" data-id="element-287">{mockContractors.length}</span>{' '}
              resultados
            </p>
          </div>
          <div data-id="element-288">
            <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" data-id="element-289">
              <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-290">
                <ChevronLeftIcon className="h-5 w-5" data-id="element-291" />
              </button>
              <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-292">
                <ChevronRightIcon className="h-5 w-5" data-id="element-293" />
              </button>
            </nav>
          </div>
        </div>
      </div>
    </div>;
};